// Values that reach the screen from lookup tables, the API or settings.
export default {
  "Staff PIN": "رمز PIN للموظفين",
  "Menu Item": "عنصر قائمة",
  "Our store": "متجرنا",
  "Find your next favorite.": "اعثر على مفضّلك القادم.",
  "Something worth gathering for.": "شيء يستحق الاجتماع من أجله.",
  "Make time for what matters.": "خصّص وقتًا لما يهمك.",
  "e.g., DWN": "مثال: DWN",
  // Days (from the availability API)
  "Sunday": "الأحد",
  "Monday": "الاثنين",
  "Tuesday": "الثلاثاء",
  "Wednesday": "الأربعاء",
  "Thursday": "الخميس",
  "Friday": "الجمعة",
  "Saturday": "السبت",
  // Stock units (stored as codes or English words)
  "piece": "قطعة",
  "pieces": "قطع",
  "pcs": "قطع",
  "kg": "كغ",
  "g": "غ",
  "l": "لتر",
  "ml": "مل",
  "box": "صندوق",
  "boxes": "صناديق",
  "pack": "علبة",
  "packs": "علب",
  "bottle": "زجاجة",
  "bottles": "زجاجات",
  "liters": "لترات",
  "units": "وحدات",
  // Business types
  "restaurant": "مطعم",
  "ecommerce": "متجر إلكتروني",
  "appointments": "مواعيد",
  "hotel": "فندق",
  "office": "مكتب",
  // Currencies
  "Moroccan Dirham": "درهم مغربي",
  "US Dollar": "دولار أمريكي",
  "Euro": "يورو",
  "British Pound": "جنيه إسترليني",
  "Canadian Dollar": "دولار كندي",
  "Australian Dollar": "دولار أسترالي",
  "Swiss Franc": "فرنك سويسري",
  "Japanese Yen": "ين ياباني",
  "Chinese Yuan": "يوان صيني",
  "UAE Dirham": "درهم إماراتي",
  "Saudi Riyal": "ريال سعودي",
  "Qatari Riyal": "ريال قطري",
  "Turkish Lira": "ليرة تركية",
  "Egyptian Pound": "جنيه مصري",
  "Swedish Krona": "كرونة سويدية",
  "Norwegian Krone": "كرونة نرويجية",
  "Danish Krone": "كرونة دنماركية",
  "Indian Rupee": "روبية هندية",
  // Order / payment / booking statuses shown from API values
  "PENDING": "قيد الانتظار",
  "AWAITING_PAYMENT": "بانتظار الدفع",
  "PARTIALLY_PAID": "مدفوع جزئيًا",
  "REFUNDED": "مسترد",
  "DELIVERY": "توصيل",
  "PICKUP": "استلام",
  "pending": "قيد الانتظار",
  "confirmed": "مؤكد",
  "cancelled": "ملغي",
  "completed": "مكتمل",
  "seated": "جالس",
  "no_show": "لم يحضر",
  "paid": "مدفوع",
  "unpaid": "غير مدفوع",
  "dine_in": "داخل المطعم",
  "takeaway": "سفري",
  "delivery": "توصيل",
  "pickup": "استلام",
  "cash": "نقدًا",
  "card": "بطاقة",
  "bank_transfer": "تحويل بنكي",
  "Login failed": "فشل تسجيل الدخول",
  "Invalid credentials": "بيانات الدخول غير صحيحة"
}
